import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    data: null,
    message: null,
    error: null,
    totalCount: null,
    suggestionData: null,
    accessData: null,
    savedData: null,
    getAccessStatus: null,
    createStatus: null,
    deleteStatus: null,
    totalSavedCount: null,
    prospectStatus: null,
    jobSuggestionData: null,
    industrySuggestionData: null,
    recentSearchedData: null,
    recentSavedData: null
}

const scrapperSlice = createSlice({
    name: 'scrapper',
    initialState,
    reducers: {
        getScrapperStart: (state) => {
            state.isLoading = true;
            state.data = null;
            state.error = null;
            state.totalCount = null;
        },
        getScrapperSuccess: (state, action) => {
            state.isLoading = false;
            state.data = action?.payload?.transformedData?.people;
            state.totalCount = action?.payload?.transformedData?.pagination?.total_entries
            // state.data = action?.payload?.people;
            // state.totalCount = action?.payload?.pagination?.total_entries
        },
        getScrapperFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        getOrgSuggestionStart: (state) => {
            state.suggestionData = null;
            state.error = null;
        },
        getOrgSuggestionSuccess: (state, action) => {
            state.suggestionData = action?.payload?.filteredData?.organizations;
        },
        getOrgSuggestionFailure: (state, action) => {
            state.error = action?.payload;
        },
        getMobileAccessStart: (state) => {
            state.isLoading = true;
            state.accessData = null;
            state.error = null;
            state.getAccessStatus = null;
        },
        getMobileAccessSuccess: (state, action) => {
            state.accessData = action?.payload?.data;
            state.isLoading = false;
            state.getAccessStatus = action?.payload?.success;
        },
        getMobileAccessFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
            state.getAccessStatus = false;
        },
        saveScrapperStart: (state) => {
            state.isLoading = true;
            state.error = null;
            state.message = null;
            state.createStatus = null;
        },
        saveScrapperSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.createStatus = action?.payload?.success;
        },
        saveScrapperFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        getSavedScrapperStart: (state) => {
            state.isLoading = true;
            state.error = null;
            state.message = null;
            state.savedData = null;
            state.totalSavedCount = null;
        },
        getSavedScrapperSuccess: (state, action) => {
            state.isLoading = false;
            state.savedData = action?.payload?.searchSave;
            state.totalSavedCount = action?.payload?.totalCount;
        },
        getSavedScrapperFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        deleteSavedScrapperStart: (state) => {
            state.isLoading = true;
            state.error = null;
            state.message = null;
            state.deleteStatus = null;
        },
        deleteSavedScrapperSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.deleteStatus = action?.payload?.success;
        },
        deleteSavedScrapperFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        saveProspectStart: (state) => {
            state.isLoading = true;
            state.error = null;
            state.message = null;
            state.prospectStatus = null;
        },
        saveProspectSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.prospectStatus = action?.payload?.success;
        },
        saveProspectFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        getJobTitleSuggestionStart: (state) => {
            state.jobSuggestionData = null;
            state.error = null;
        },
        getJobTitleSuggestionSuccess: (state, action) => {
            state.jobSuggestionData = action?.payload?.jobTitles;
        },
        getJobTitleSuggestionFailure: (state, action) => {
            state.error = action?.payload;
        },
        getIndustrySuggestionStart: (state) => {
            state.industrySuggestionData = null;
            state.error = null;
        },
        getIndustrySuggestionSuccess: (state, action) => {
            state.industrySuggestionData = action?.payload?.departments;
        },
        getIndustrySuggestionFailure: (state, action) => {
            state.error = action?.payload;
        },
        getRecentSaveStart: (state) => {
            state.isLoading = true;
            state.recentSavedData = null;
            state.error = null;
        },
        getRecentSaveSuccess: (state, action) => {
            state.isLoading = false;
            state.recentSavedData = action?.payload?.recentSave;
        },
        getRecentSaveFailure: (state, action) => {
            state.isLoading = false;
            state.error = action?.payload;
        },
        getRecentSearchStart: (state) => {
            state.isLoading = true;
            state.recentSearchedData = null;
            state.error = null;
        },
        getRecentSearchSuccess: (state, action) => {
            state.isLoading = false;
            state.recentSearchedData = action?.payload?.recentSearch;
        },
        getRecentSearchFailure: (state, action) => {
            state.isLoading = false;
            state.error = action?.payload;
        },
        resetData: (state) => {
            state.data = null;
        },
        resetCreateState: (state) => {
            state.isLoading = null;
            state.error = null;
            state.message = null;
            state.createStatus = null;
        },
        resetDeleteState: (state) => {
            state.isLoading = null;
            state.error = null;
            state.message = null;
            state.deleteStatus = null;
        },
        resetProspectState: (state) => {
            state.isLoading = null;
            state.error = null;
            state.message = null;
            state.prospectStatus = null;
        },
    }
});

export const {
    getScrapperStart,
    getScrapperSuccess,
    getScrapperFailure,
    getOrgSuggestionStart,
    getOrgSuggestionSuccess,
    getOrgSuggestionFailure,
    getMobileAccessStart,
    getMobileAccessSuccess,
    getMobileAccessFailure,
    saveScrapperStart,
    saveScrapperSuccess,
    saveScrapperFailure,
    getSavedScrapperStart,
    getSavedScrapperSuccess,
    getSavedScrapperFailure,
    deleteSavedScrapperStart,
    deleteSavedScrapperSuccess,
    deleteSavedScrapperFailure,
    saveProspectStart,
    saveProspectSuccess,
    saveProspectFailure,
    getJobTitleSuggestionStart,
    getJobTitleSuggestionSuccess,
    getJobTitleSuggestionFailure,
    getIndustrySuggestionStart,
    getIndustrySuggestionSuccess,
    getIndustrySuggestionFailure,
    getRecentSaveStart,
    getRecentSaveSuccess,
    getRecentSaveFailure,
    getRecentSearchStart,
    getRecentSearchSuccess,
    getRecentSearchFailure,
    resetData,
    resetCreateState,
    resetDeleteState,
    resetProspectState
} = scrapperSlice?.actions;

export default scrapperSlice?.reducer;